export const getUserAuthState = (state: any) => state?.user?.isAuthenticated;
